import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "bfo9j1ak",
  dataset: "production",
  useCdn: false,
  apiVersion: "2022-10-11",
});
